import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import SEO from '../components/SEO';
import { SEDES, aniosDeTrayectoria } from '../data/organizacion';
import logo from '../assets/img/gifs/LogoGif-small.webp';
import cocina from '../assets/img/hero/imagen_cocina.webp'
import temperley from '../assets/img/hero/temperley_frente_nwsp.webp'
import glew from '../assets/img/hero/glew_frente_nwsp.webp'
import feria from '../assets/img/hero/feria.webp'
import actividadInterior from '../assets/img/hero/actividad-terapeutica-interior.webp'
import actividadExterior from '../assets/img/hero/actividad-grupal-aire-libre.webp'
import motivoTrayectoria from '../assets/img/motivos/motivo-trayectoria.webp'
import motivoEquipo from '../assets/img/motivos/motivo-equipo.webp'
import motivoAtencion from '../assets/img/motivos/motivo-atencion.webp'
import temperley_bw from '../assets/img/TemperleyBW.webp'
import temperley_frente from '../assets/img/Temperley_Frente.webp'
import glew_frente from '../assets/img/Glew_Frente.webp'

const gtag_report_conversion = (url) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16956303663/7KnDCOiB6qIcEK_SspU_',
      'event_callback': function () {
        if (typeof(url) !== 'undefined') {
          window.location = url;
        }
      }
    });
  } else {
    window.location = url;
  }
};

// Flecha del sistema de diseño, usada en botones-tarjeta y enlaces.
const Arrow = ({ className = 'card-btn-arrow' }) => (
  <svg className={className} viewBox="0 0 42 38" fill="none" aria-hidden="true">
    <path d="M0 18.5164L38.2279 18.5165" stroke="currentColor" strokeWidth="3.45872" />
    <path d="M21.7065 1.22284L39 18.5165L21.7065 35.8101" stroke="currentColor" strokeWidth="3.45872" />
  </svg>
);

const LandingPage = () => {
  const galleryImages = [
    { src: temperley, alt: 'Centro Educativo Terapéutico Temperley - CET zona sur' },
    { src: glew, alt: 'Centro de Día Glew - CD para personas con discapacidad' },
    { src: cocina, alt: 'Taller de cocina - Actividades para personas con discapacidad intelectual' },
    { src: feria, alt: 'Actividades terapéuticas - CET y CD zona sur' },
    { src: actividadInterior, alt: 'Actividad terapéutica artística en el Centro de Día Mi Lugar' },
    { src: actividadExterior, alt: 'Actividad grupal al aire libre para jóvenes con discapacidad' }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  // Diferir la carga de slides 2-4 para no competir con el LCP del primer slide.
  // El primer slide carga inmediatamente; el resto se solicita ~800ms después.
  const [slidesToLoad, setSlidesToLoad] = useState(1);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.__PRERENDERING) return;
    const t = setTimeout(() => setSlidesToLoad(galleryImages.length), 800);
    return () => clearTimeout(t);
  }, [galleryImages.length]);

  useEffect(() => {
    const id = setInterval(() => {
      setCurrentIndex((c) => (c + 1) % galleryImages.length);
    }, 5000);
    return () => clearInterval(id);
  }, [currentIndex, galleryImages.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <>
      <SEO
        title="Mi Lugar — CET y Centro de Día | Discapacidad Zona Sur"
        description={`Centro Educativo Terapéutico (CET) y Centro de Día en Temperley y Glew. Atención especializada en discapacidad intelectual. Obras sociales. ${aniosDeTrayectoria()} años en zona sur.`}
        path="/"
      />

      {/* Hero: texto y CTAs a la izquierda, galería de fotos a la derecha */}
      <header className="hero">
        <div className="shell">
          <div className="hero-grid">
            <div className="hero-left">
              <div className="hero-panel">
                <h1 className="h-display">Un lugar<br />para crecer.</h1>
                <p className="lede">
                  Centro de Día y Centro Educativo Terapéutico en Temperley y Glew.
                  Más de {aniosDeTrayectoria()} años acompañando a niños y jóvenes con discapacidad en la zona sur.
                </p>
              </div>

              <div className="hero-actions">
                <Link to="/contacto" className="card-btn is-ink">
                  <span className="card-btn-label">Contactanos</span>
                  <Arrow />
                </Link>
                <a
                  href={SEDES[0].whatsapp}
                  className="card-btn is-accent"
                  onClick={(e) => {
                    e.preventDefault();
                    gtag_report_conversion(SEDES[0].whatsapp);
                  }}
                >
                  <span className="card-btn-label">
                    <FaWhatsapp className="card-btn-icon" /> WhatsApp
                  </span>
                  <Arrow />
                </a>
              </div>
            </div>

            <div className="hero-right">
              <div className="stage">
                {galleryImages.map((image, index) => (
                  <img
                    key={index}
                    src={index < slidesToLoad ? image.src : undefined}
                    alt={image.alt}
                    className={`stage-shot${index === currentIndex ? ' active' : ''}`}
                    fetchpriority={index === 0 ? 'high' : 'auto'}
                    loading={index === 0 ? 'eager' : 'lazy'}
                    decoding="async"
                  />
                ))}
              </div>

              {/* El GIF del logo es transparente: el chip de vidrio es lo que
                  mantiene legible el subtítulo sobre cualquiera de las fotos. */}
              <div className="gif-chip">
                <img src={logo} alt="Mi Lugar - Centro Educativo Terapéutico CET y Centro de Día CD" />
              </div>

              <div className="slider-indicators">
                {galleryImages.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    className={`slider-dot ${index === currentIndex ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                    aria-label={`Ir a imagen ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Acerca de nosotros */}
      <section className="section">
        <div className="shell">
          <div className="statement">
            <p className="eyebrow">CET y CD Zona Sur</p>
            <h2 className="h-statement">
              Mi Lugar es un Centro de Día y Centro Educativo Terapéutico fundado en 1982,
              con {aniosDeTrayectoria()} años acompañando a niños y jóvenes con discapacidad.
            </h2>
          </div>

          <div className="about-grid">
            <div className="about-copy">
              <p className="body-text">
                Fundado por la Lic. Mirtha Wechsung, nuestro enfoque se centra en el desarrollo
                integral de cada individuo, potenciando sus habilidades y fomentando su autonomía
                a través de metodologías terapéuticas innovadoras.
              </p>
              <p className="body-text">
                Ofrecemos un espacio de contención, aprendizaje y crecimiento, donde cada niño y
                joven puede desarrollar al máximo sus capacidades en un ambiente cálido y seguro.
              </p>
              <Link to="/tratamientos" className="link-arrow">
                Conocé nuestros tratamientos
                <Arrow className="" />
              </Link>
            </div>
            <div className="about-media">
              <img src={temperley_bw} alt="Fachada histórica de Mi Lugar en Temperley, centro terapéutico fundado en 1982" />
            </div>
          </div>
        </div>
      </section>

      {/* Por qué elegirnos */}
      <section className="section-tight">
        <div className="shell">
          <div className="statement">
            <p className="eyebrow">Por qué elegirnos</p>
            <h2 className="h-section">Tres cosas que no se improvisan.</h2>
          </div>

          <div className="reasons">
            <article className="reason is-blue">
              <img
                className="reason-media"
                src={motivoTrayectoria}
                alt=""
                loading="lazy"
                decoding="async"
              />
              <h3 className="h-card">Más de {aniosDeTrayectoria()} años de experiencia</h3>
              <p className="body-text">
                Fundados en 1982, contamos con una larga trayectoria brindando atención
                especializada y de calidad.
              </p>
            </article>

            <article className="reason is-rose">
              <img
                className="reason-media"
                src={motivoEquipo}
                alt=""
                loading="lazy"
                decoding="async"
              />
              <h3 className="h-card">Equipo interdisciplinario</h3>
              <p className="body-text">
                Profesionales especializados trabajan en conjunto para ofrecer una atención
                integral y personalizada.
              </p>
            </article>

            <article className="reason is-deep">
              <img
                className="reason-media"
                src={motivoAtencion}
                alt=""
                loading="lazy"
                decoding="async"
              />
              <h3 className="h-card">Atención personalizada</h3>
              <p className="body-text">
                Desarrollamos planes terapéuticos específicos para cada niño o joven, respetando
                sus tiempos y necesidades.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* Sedes */}
      <section className="section-tight">
        <div className="shell">
          <div className="statement">
            <p className="eyebrow">Nuestras sedes</p>
            <h2 className="h-section">Dos sedes, el mismo amor.</h2>
          </div>

          <div className="sedes-grid">
            <article className="sede-card">
              <div className="sede-card-photo">
                <img src={temperley_frente} alt="Frente de la sede Temperley de Mi Lugar, en A. Gallardo 646" loading="lazy" decoding="async" />
              </div>
              <div className="sede-card-body">
                <h3 className="h-card">Sede Temperley</h3>
                <p className="body-text">
                  A. Gallardo 646. Nuestra sede principal ofrece instalaciones completas y un
                  ambiente cálido para el desarrollo de nuestras actividades.
                </p>
                <Link to="/temperley" className="link-arrow">
                  Conocer más
                  <Arrow className="" />
                </Link>
              </div>
            </article>

            <article className="sede-card">
              <div className="sede-card-photo">
                <img src={glew_frente} alt="Frente de la sede Glew de Mi Lugar, en Av. Hipólito Yrigoyen 22548, Guernica" loading="lazy" decoding="async" />
              </div>
              <div className="sede-card-body">
                <h3 className="h-card">Sede Glew</h3>
                <p className="body-text">
                  Av. Hipólito Yrigoyen 22548, Guernica. Un espacio amplio y adaptado para brindar
                  todas nuestras terapias y actividades.
                </p>
                <Link to="/glew" className="link-arrow">
                  Conocer más
                  <Arrow className="" />
                </Link>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* Cierre */}
      <section className="section-tight">
        <div className="shell">
          <div className="cta-section">
            <div className="cta-content">
              <h2>¿Necesitás más información?</h2>
              <p>
                Estamos acá para ayudarte y responder todas tus preguntas. Contactanos o visitanos
                en cualquiera de nuestras sedes.
              </p>
              <div className="cta-buttons is-cards">
                <Link to="/contacto" className="card-btn is-white">
                  <span className="card-btn-label">Contactar ahora</span>
                  <Arrow />
                </Link>
                <a
                  href={SEDES[0].whatsapp}
                  className="card-btn is-accent"
                  onClick={(e) => {
                    e.preventDefault();
                    gtag_report_conversion(SEDES[0].whatsapp);
                  }}
                >
                  <span className="card-btn-label">
                    <FaWhatsapp className="card-btn-icon" /> Escribinos
                  </span>
                  <Arrow />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp flotante, con reporte de conversión */}
      <a
        href={SEDES[1].whatsapp}
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Escribinos por WhatsApp"
        onClick={(e) => {
          e.preventDefault();
          gtag_report_conversion(SEDES[1].whatsapp);
        }}
      >
        <FaWhatsapp />
      </a>
    </>
  );
};

export default LandingPage;
